import axios from 'axios';
import { useEffect, useState } from 'react';

const YOUTUBE_API_KEY = "AIzaSyD5ZzffYrcSTfMo8YpZnDhtECIrAvQf1TI";

export default function Project(){
    const [videos, setVideos] = useState([]);
   
    useEffect(() => {
    const fetchVideos = async () => {
      try {
        const res = await axios.get(
          "https://www.googleapis.com/youtube/v3/search",
          {
            params: {
              key: YOUTUBE_API_KEY,
              q: "trending", // You can change this to anything like "funny", "music", "tech" etc.
              part: "snippet",
              maxResults: 10,
              type: "video",
              order: "relevance", // or 'date', 'rating', etc.
              safeSearch: "strict",
            },
          }
        );

        setVideos(res.data.items);
      } catch (err) {
        console.error("Error fetching videos", err);
      }
    };

    fetchVideos();
  }, []);
    
    return (
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold mb-12 text-center">Featured Videos</h2>

          {/* Scrollable container */}
          <div className="overflow-x-hidden scrollbar-hide w-full">
            <div className="flex gap-6 min-w-full md:min-w-[900px] animate-carousel">
              {[...videos, ...videos].map((video, index) => (
                <div
                  key={video.id.videoId || index}
                  className="min-w-[300px] bg-black rounded-lg overflow-hidden shadow-gray-800 shadow-md hover:shadow-lg transition-shadow"
                >
                  <div className="aspect-video bg-black border border-gray-800">
                    <img
                      src={video.snippet.thumbnails.medium.url}
                      alt={video.snippet.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-bold mb-2 line-clamp-2">{video.snippet.title}</h3>
                    <p className="text-gray-600 mb-4 line-clamp-2">
                      {video.snippet.description}
                    </p>
                    <div className="flex gap-2 mb-6">
                      <span className="px-3 py-1 bg-purple-100 text-purple-800 rounded-full text-xs">
                        CQZ
                      </span>
                      <span className="px-3 py-1 bg-purple-100 text-purple-800 rounded-full text-xs">
                        {video.snippet.channelTitle}
                      </span>
                    </div>
                    <div className="flex gap-4">
                      <a
                        href={`https://www.youtube.com/watch?v=${video.id.videoId}`}
                        className="text-purple-800 hover:underline text-sm font-medium"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Watch
                      </a>
                      <a href="#" className="text-purple-800 hover:underline text-sm font-medium">
                        Add to playlist
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Optional: View All Button */}
          <div className="text-center mt-12">
            <a
              href="#"
              className="px-6 py-3 text-purple-800 border border-purple-800 rounded-md hover:bg-purple-50 inline-block"
            >
              View All Videos
            </a>
          </div>
        </div>
    );
}